import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";

const RouteChangeHandler = () => {
    const location = useLocation();
    const prevPathRef = useRef(location.pathname);

    useEffect(() => {
        const prevPath = prevPathRef.current;
        const currentPath = location.pathname;

        if (
            prevPath.startsWith("/Initiate-Sales-Claim") &&
            !currentPath.startsWith("/Initiate-Sales-Claim")
        ) {
            sessionStorage.removeItem("searchResults");
        }

        Swal.close();

        prevPathRef.current = currentPath;
    }, [location]);


    return null;
};

export default RouteChangeHandler;